import { Partner } from "@/data/partners";

export const getPartnerImage = (partner: Partner): string => {
  if (partner.main_image) {
    return partner.main_image;
  }

  const categoryId = partner.category.toLowerCase();
  const defaultImages: Record<string, string> = {
    architecture:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&auto=format&fit=crop",
    "architecture & design":
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&auto=format&fit=crop",
    technology:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&auto=format&fit=crop",
    "f&b consultants":
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&auto=format&fit=crop",
    operations:
      "https://images.unsplash.com/photo-1564501049418-3c27787d01e8?w=800&auto=format&fit=crop",
    "legal & finance":
      "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&auto=format&fit=crop",
    "development & construction":
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&auto=format&fit=crop",
    financial:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&auto=format&fit=crop",
  };

  return (
    defaultImages[categoryId] ||
    "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800&auto=format&fit=crop"
  );
};

export const getPartnerBadge = (partner: Partner): string => {
  if (partner.rating >= 4.5) return "Top Rated";
  if (partner.project_count > 100) return "Experienced";
  if (partner.discount_code) return "Exclusive Deal";
  return "Verified";
};
